import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useHistory } from 'react-router-dom';
import { PlusCircleOutlined } from '@ant-design/icons';
import * as S from './styles';

export function Header(): JSX.Element {
	const history = useHistory();

	function handleOnClick(): void {
		history.push('/custom-reports/resolution-886/report');
	}

	return (
		<Row justify="space-between">
			<Col>
				<S.TitleWrapper>Resolution 886</S.TitleWrapper>
			</Col>
			<Col span={0.1}>
				<S.ButtonWrapper type="primary" icon={<PlusCircleOutlined />} onClick={handleOnClick}>
					{I18n.get('New evaluation')}
				</S.ButtonWrapper>
			</Col>
		</Row>
	);
}
